// import CubesImg from "public/kubernetes/implementation/fa6-solid_cubes.png";
import RocketImg from "public/kubernetes/implementation/fa6-solid_rocket.png";
import BoltImg from "public/kubernetes/implementation/material-symbols_bolt-rounded.png";
import GraphImg from "public/kubernetes/implementation/octicon_graph-16.png";
import LastUpdatesImg from "public/kubernetes/implementation/stash_last-updates.png";
import LockOffImg from "public/kubernetes/implementation/tdesign_lock-off-filled.png";
import SecuredImg from "public/kubernetes/implementation/tdesign_secured-filled.png";

export const K8S_GETTING_STARTED = {
  title: "Getting Started with Kubernetes on OneMind",
  list: [
    {
      image: SecuredImg,
      title: "1. Provision a K8s Cluster",
      content:
        "Use the dashboard or API to select region, instance type, autoscaling configs, and spin up a new Kubernetes cluster.",
    },
    {
      image: LockOffImg,
      title: "2. Define Access Controls",
      content:
        "Implement RBAC policies to control access by team, role, or service — ensuring your clusters remain secure and compliant.",
    },
    {
      image: RocketImg,
      title: "3. Deploy via Helm, kubectl, or GitOps",
      content:
        "Connect your CI/CD tools or use built-in deployment tools to release applications using Helm charts, kubectl, or GitOps workflows.",
    },
    {
      image: BoltImg,
      title: "4. Configure Auto-Scaling Policies",
      content:
        "Set up horizontal and vertical scaling policies based on real-time load metrics to dynamically scale pods and nodes.",
    },
    {
      image: GraphImg,
      title: "5. Monitor and Observe",
      content:
        "Gain real-time insights into cluster health, workload performance, and logs via integrated dashboards.",
    },
    {
      image: LastUpdatesImg,
      title: "6. Maintain with Zero Downtime",
      content:
        "Perform rolling updates and infrastructure maintenance without interrupting running applications, ensuring high availability.",
    },
  ],
};
